import { Tenant } from 'state/tenant';
import { Theme as MUITheme } from '@material-ui/core';
import { createMuiTheme } from '@material-ui/core/styles';

import { QueryParameters } from 'hooks/useQueryParameters';

export interface Theme {
  mui: MUITheme;

  shape: {
    borderRadiusSmall: number;
    borderRadiusLarge: number;
  };

  header: {
    backgroundColor: string;
    textColor: string;
  };
  embedded: boolean;
}

export default (tenant: Tenant, queryParams: QueryParameters): Theme => {
  const muiTheme = createMuiTheme({
    palette: {
      primary: {
        main: tenant.brandColor,
      },
      secondary: {
        main: tenant.brandColor,
      },
      tonalOffset: 0.65,
      error: {
        main: '#E82117',
      },
    },
    typography: {
      fontSize: 14,
      htmlFontSize: 10,
    },
  });

  return {
    mui: muiTheme,

    shape: {
      borderRadiusSmall: muiTheme.shape.borderRadius,
      borderRadiusLarge: muiTheme.shape.borderRadius * 5,
    },

    header: {
      backgroundColor: muiTheme.palette.common.black,
      textColor: muiTheme.palette.common.white,
    },

    embedded: queryParams.embedded,
  };
};
